import { __extends } from "tslib";
import React from 'react';
/**
 * Stop scroll events from leaking up into the parent, this means
 * that if you have small scroll area you can stop the browser
 * window scrolling when scrolling that internal area.
 *
 * Note: No throttling etc here because we need to stop the event
 * and event are sync not async, so calling preventDefault inside
 * any async op is a noop.
 *
 * TODO: maybe look adding flag so we stop next event(s) rather than
 * the one inside the asyc handler.
 */
var NoLeakyScroll = /** @class */ (function (_super) {
    __extends(NoLeakyScroll, _super);
    function NoLeakyScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.handleWheel = function (e) {
            var el = _this.scrollRef.current;
            if (e.deltaY < 0 && el.scrollTop === 0) {
                e.preventDefault();
            }
            if (e.deltaY > 0 && el.scrollTop === el.scrollHeight - el.offsetHeight) {
                e.preventDefault();
            }
        };
        _this.scrollRef = React.createRef();
        return _this;
    }
    NoLeakyScroll.prototype.render = function () {
        return (React.createElement("div", { ref: this.scrollRef, onWheel: this.handleWheel, style: { overflowY: 'auto' }, className: this.props.className }, this.props.children));
    };
    return NoLeakyScroll;
}(React.Component));
export default NoLeakyScroll;
//# sourceMappingURL=NoLeakyScroll.js.map